import { SDKOptions, SportTypes } from '../types';
import { getStandings, IStandingsProps } from '../services/ice-hockey/standings';
import { getStandingsCompetitionDetails, IStandingsCompetitionDetailsProps } from '../services/ice-hockey/standingsCompetitionDetails';
import { IPlayoffResponse, IStandingsCompetitionDetailsResponse, IStandingsRawResponse } from '../types/standings';
import { getPlayoffs, IPlayoffDataArguments } from '../services/multi-sport/playoffs';

export interface IIceHockeyStandingApi {
  getStandings: (params: IStandingsProps, sdkOptions: SDKOptions, sport: SportTypes) => Promise<IStandingsRawResponse | any>;
  getStandingsCompetitionDetails: (
    params: IStandingsCompetitionDetailsProps,
    sdkOptions: SDKOptions,
    sport: SportTypes,
  ) => Promise<IStandingsCompetitionDetailsResponse[] | any>;
  getPlayoffs: (params: IPlayoffDataArguments, sdkOptions: SDKOptions, sport: SportTypes) => Promise<IPlayoffResponse | any>;
}

export const iceHockeyStandingsApi = (): IIceHockeyStandingApi => {
  return {
    getStandings: (params, sdkOptions, sport) => getStandings({ params, sdkOptions, sport }),
    getStandingsCompetitionDetails: (params: IStandingsCompetitionDetailsProps, sdkOptions: SDKOptions, sport: SportTypes) =>
      getStandingsCompetitionDetails({
        params,
        sdkOptions,
        sport,
      }),
    getPlayoffs: (params: IPlayoffDataArguments, sdkOptions: SDKOptions, sport: SportTypes) =>
      getPlayoffs({
        params,
        sdkOptions,
        sport,
      }),
  };
};
